import {
  CaretRightOutlined,
  RightOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Collapse,
  Row,
  Col,
  Steps,
  Button,
  message,
  Form,
  Input,
  Image,
  Carousel,
  Card,
  Divider,
  Select,
  DatePicker,
  Radio,
  Checkbox,
  Space,
  Avatar,
  Spin,
  Upload,
} from "antd";
import React, { useEffect, useState, useRef } from "react";
import FileUploadWithCrop from "./FileUploadWithCrop";
import RegistrationService from "../../api/registration.service";
import commonUtility from "../../utility/Utils";
import {
  DATE_FORMAT_DMY_SLASH,
  REQUIRED_FIELD_ERROR,
  SUCCESS_STATUS,
  TRY_AGAIN_ERROR,
} from "../../utility/Constants";
import { useParams } from "react-router-dom";
import ProgrammeService from "../../api/programme.service";
import moment from "moment";

import InputMask from "react-input-mask";
import occupationService from "../../api/occupation.service";
import CustomFileUploadProfile from "./CustomFileUploadProfile";
import ModalWithMessageAndAction from "../common/ModalWithMessageAndAction";
import DateInput from "../common/DateInput";
import ModalWithMessageAndActionReg from "../common/ModalWithMessageAndActionReg";
const { Panel } = Collapse;
const { Option } = Select;
const { TextArea } = Input;

const defaultFormValues = {
  memberId: 0,
  mode: "ADD",
  member_code: "",
  reg_type: "STUDENT",
  // date_of_join: null,
  member_fname: "",
  member_lname: "",
  primary_mobile: "",
  whatsapp_no: "",
  mobile_two: "",
  mobile_three: "",
  primary_email: "",
  email_second: "",
  address_one: "",
  address_two: "",
  // date_of_birth: null,
  gender: "M",

  father_name: "",
  father_mobile: "",
  father_occupation_id: "",

  monther_name: "",
  mother_mobile: "",
  mother_occupation_id: "",

  school: "",
  mem_class: "",
  weekly_holiday: "",
  school_timing: "",

  is_begineer: false,
  // playing_for: "",
  earlier_playing: "",

  billing_name: "",
  gstin_no: "",

  father_company: "",
  mother_company: "",

  file: null,
  is_file_change: "N",
  is_file_deleted: "N",
};

const BasicregWithCollapse = () => {
  const [isFileUploadBtnDisable, setIsFileUploadBtnDisable] = useState(true);
  const [isSaveLoaderEnable, setIsSaveLoaderEnable] = useState(false);

  const params = useParams();

  const [totalRegistration, setTotalRegistration] = useState(0);
  const [totalMemberRegistered, setTotalMemberRegistered] = useState(0);
  const [totalStudentRegistered, setTotalStudentRegistered] = useState(0);
  const [totalMalecount, setTotalMalecount] = useState(0);
  const [totalFemalecount, setTotalFemalecount] = useState(0);
  const [totalTransgenderecount, setTotalTransgenderecount] = useState(0);
  const [savedMemberId, setSavedmemberId] = useState(0);

  const [editMemberProfilePic, setEditMemberProfilePic] = useState("");
  const [laravelImagePath, setLaravelImagePath] = useState(false);

  const [occupationList, setOccupationList] = useState([]);
  const [previewUrl, setPreviewUrl] = useState(null);

  const [isDOBValidationError, setIsDOBValidationError] = useState(false);
  const [dOBValidationErrorMsg, setDOBValidationErrorMsg] = useState("");

  const [dob, setDob] = useState(null);

  const [form] = Form.useForm();

  const [responseModal, setResponseModal] = useState({
    responseModalTitle: "",
    isOpenModal: false,
    listLink: "",
    addmoreLink: "",
    responseModalMessage: "",
    printReuired: false,
  });

  const inputFileRef = useRef();
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    form.setFieldsValue({
      is_file_change: "Y",
    });
    form.setFieldsValue({
      file: e.target.files[0],
    });
  };

  const onBtnClick = () => {
    inputFileRef.current.click();
  };
  const removePhoto = () => {
    setFile(null);
    form.setFieldsValue({
      is_file_deleted: "Y",
    });
  };

  const onBasicInfoSave = async (values) => {
    let data = new FormData();


    data.append("formdata", JSON.stringify(values));
    data.append("file", values.file);

    if (dobValidation(values.date_of_birth)) {
      setIsSaveLoaderEnable(true);
      //  const data = { formdata: values, };
      RegistrationService.RegBasicInfoSaveWithFile(data)
        .then((res) => {
          if (res.data.response_status == SUCCESS_STATUS) {
            const saved_data = res.data.response_data;
            if (form.getFieldValue("mode") == "ADD") {
              form.setFieldsValue({
                memberId: saved_data.insertId,
                mode: "EDIT",
              });
            }

            setIsFileUploadBtnDisable(false);
            setSavedmemberId(saved_data.insertId);
            //commonUtility.openNotification("bottom", "Message", res.data.response_msg);

            setResponseModal({
              responseModalTitle: "Success",
              isOpenModal: true,
              listLink: "/member-list",
              addmoreLink: "/registration",
              responseModalMessage: res.data.response_msg,
              printReuired: false,
            });
          } else {
            commonUtility.openNotificationWithType(
              "error",
              "bottomRight",
              "Error",
              TRY_AGAIN_ERROR
            );
          }
        })
        .then(() => {
          setIsSaveLoaderEnable(false);
        });
    }
  };

  const onFinishFailed = (errorInfo) => {
    commonUtility.openNotificationWithType(
      "error",
      "bottomRight",
      "Validation Error",
      REQUIRED_FIELD_ERROR
    );
  };

  const onChange = (date, dateString) => {
    console.log(date, dateString);
  };

  // const onDateOfBirthChange = (date, dateString) => {
  //     form.setFieldsValue({
  //         date_of_birth: dateString,
  //     });
  // };

  const onDateOfBirthChange = (value) => {
    setDob(value);
  };

  const onGenderChange = (e) => {
    console.log(`radio checked:${e.target.value}`);
  };

  const onIsBeginerChange = (e) => {
    // console.log(`checked = ${e.target.checked}`);
  };

  const onChangeCollapse = (key) => {
    console.log(key);
  };

  const handleMobileNumberInput = (event, field) => {
    console.log("event", event);
    console.log("field", field);
    const result = commonUtility.allowOnlyNumber(event.target.value);

    if (field == "primary_mobile") {
      form.setFieldsValue({
        primary_mobile: result,
      });
    } else if (field == "whatsapp_no") {
      form.setFieldsValue({
        whatsapp_no: result,
      });
    } else if (field == "father_mobile") {
      form.setFieldsValue({
        father_mobile: result,
      });
    } else if (field == "mother_mobile") {
      form.setFieldsValue({
        mother_mobile: result,
      });
    }
  };
  const handleWhatsAppNumberInput = (event) => {
    const result = commonUtility.allowOnlyNumber(event.target.value);
    form.setFieldsValue({
      whatsapp_no: result,
    });
  };

  useEffect(() => {
    RegistrationService.registrationCount().then((res) => {
      let counts = res.data.response_data[0];
      //console.log("tyasdjfgjsdgfu u",res.data.response_data[0])
      setTotalRegistration(counts.reg_count);
      setTotalMemberRegistered(counts.member_count);
      setTotalStudentRegistered(counts.student_count);
      setTotalMalecount(counts.gender_count_male);
      setTotalFemalecount(counts.gender_count_female);
      setTotalTransgenderecount(counts.gender_count_tran);
    });
  }, []);

  // Edit Mode
  useEffect(() => {
    setSavedmemberId(params.memberid);
  }, [params.memberid]);

  useEffect(() => {
    occupationService.list().then((res) => {
      setOccupationList(res.data.response_data);
    });
  }, []);

  useEffect(() => {
    if (savedMemberId > 0) {
      const data = { formdata: { member_id: savedMemberId } };
      ProgrammeService.memberInfoByID(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          const response = res.data.response_data[0];

          form.setFieldsValue({
            memberId: response.member_id,
            mode: "EDIT",
            member_code: response.member_code,
            reg_type: response.reg_type,
            // date_of_join: response.date_of_join,
            member_fname: response.member_fname,
            member_lname: response.member_lname,
            primary_mobile: response.primary_mobile,
            whatsapp_no: response.whatsapp_no,
            mobile_two: response.mobile_two,
            mobile_three: response.mobile_three,
            primary_email: response.primary_email,
            email_second: response.email_second,
            address_one: response.address_one,
            address_two: response.address_two,
            // date_of_birth_picker: response.date_of_birth != null && response.date_of_birth != "" ? moment(response.date_of_birth, DATE_FORMAT_DMY_SLASH) : '',
            date_of_birth: response.date_of_birth,
            gender: response.gender,

            father_name: response.father_name,
            father_mobile: response.father_mobile,
            father_company: response.father_company,
            father_occupation_id:
              commonUtility.sanitizeValue(response.father_occupation_id) > 0
                ? response.father_occupation_id
                : "",

            monther_name: response.monther_name,
            monther_company: response.monther_company,
            mother_mobile: response.mother_mobile,
            mother_occupation_id:
              commonUtility.sanitizeValue(response.mother_occupation_id) > 0
                ? response.mother_occupation_id
                : "",

            school: response.school,
            mem_class: response.mem_class,
            weekly_holiday: response.weekly_holiday,
            school_timing: response.school_timing,
            // occupation_id: response.occupation_id,
            is_begineer: false,
            // playing_for: "",
            earlier_playing: response.earlier_playing,

            billing_name: response.billing_name,
            gstin_no: response.gstin_no,
            is_file_change: "N",
            is_file_deleted: "N",
          });

          if (commonUtility.sanitizeObject(response.member_portal_profile_picture ? response.member_portal_profile_picture : response.profile_picture)) {
            setEditMemberProfilePic(response.member_portal_profile_picture ? response.member_portal_profile_picture : response.profile_picture);
            setLaravelImagePath(response.member_portal_profile_picture ? true : false);
            setIsFileUploadBtnDisable(false);
          }

          setDob(response.date_of_birth);
        }
      });
    }
  }, [savedMemberId]);

  const handleDateChange = (event) => {
    //console.log('event',event.target.value);
    // setDate(event.target.value);
    dobValidation(event.target.value);
    setDob(event.target.value);
  };

  const dobValidation = (dateString) => {
    setIsDOBValidationError(false);
    setDOBValidationErrorMsg("");

    let dateValue = dateString?.replace(/_/g, "");
    if (dateValue == null || dateValue == "" || dateValue == "//") {
      form.setFieldsValue({
        date_of_birth: "",
      });
      // setIsDOBValidationError(true)
      // setDOBValidationErrorMsg("DOB is required")
      // return false

      setIsDOBValidationError(false);
      setDOBValidationErrorMsg("");
      return true;
    } else {
      if (dateString != "") {
        form.setFieldsValue({
          date_of_birth: dateString,
        });
        if (isValidDate(dateString)) {
          setIsDOBValidationError(false);
          setDOBValidationErrorMsg("");
          return true;
        } else {
          setIsDOBValidationError(true);
          setDOBValidationErrorMsg("Date of birth is not valid");
          return false;
        }
      } else {
        return true;
      }
    }
  };

  const isValidDate = (dateString) => {
    const dateArray = dateString.split("/");
    const ddmmyyyy = dateArray[1] + "/" + dateArray[0] + "/" + dateArray[2];
    const date = new Date(ddmmyyyy);
    return !isNaN(date.getTime());
  };

  return (
    <div className="form-input-style">
      <Row
        className="login-first-step-row"
        style={{ background: "transparent" }}
      >
        <Col className="login-first-step-block-1" xs={24} xl={24}>
          <Form
            form={form}
            layout="vertical"
            onFinish={onBasicInfoSave}
            autoComplete="off"
            initialValues={defaultFormValues}
            className="basicRegForm"
            onFinishFailed={onFinishFailed}
            encType="multipart/form-data"
          >
            <Collapse
              bordered={false}
              defaultActiveKey={["1", "2", "3", "4", "5"]}
              onChange={onChangeCollapse}
              expandIcon={({ isActive }) => (
                <CaretRightOutlined rotate={isActive ? 90 : 0} />
              )}
            >
              <Panel
                header="Personal Info"
                key="1"
                style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }}
              >
                <Row gutter={20}>
                  <Col xs={24} xl={14}>
                    <Row gutter={20}>
                      <Col xs={24} sm={12}>
                        <Form.Item name="member_code" label="Member Code">
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                        <Form.Item
                          name="memberId"
                          label="memberId"
                          hidden={true}
                        >
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="mode" label="mode" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12}>
                        <Form.Item name="reg_type" label="Reg Type">
                          <Radio.Group
                            style={{ width: "100%" }}
                            optionType="button"
                            buttonStyle="solid"
                          >
                            <Radio.Button value="STUDENT">Student</Radio.Button>
                            <Radio.Button value="MEMBER">Member</Radio.Button>
                            <Radio.Button value="NON-MEMBER">
                              Non Member
                            </Radio.Button>
                          </Radio.Group>
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12}>
                        {/* <Form.Item name="date_of_birth_picker" label="DOB*" rules={[
                                                    {
                                                        required: true,
                                                        message: 'DOB is required',
                                                    },
                                                ]}>
                                                     <DatePicker
                                                        format="DD/MM/YYYY"
                                                        onChange={onDateOfBirthChange}
                                                        style={{ width: "100%" }}
                                                      
                                                        showToday={false}
                                                        showTime={false}
                                                        open={false}
                                               
                                                    /> 
                                                </Form.Item> */}

                        {/* <Form.Item
                                            name="date_of_birth"
                                            label="DOB*"
                                            rules={[
                                                {
                                                required: true,
                                                message: 'DOB is required',
                                                },
                                            ]}
                                            >
                                             <DatePicker
                                                //value={dob}
                                                onChange={onDateOfBirthChange}
                                                format="DD/MM/YYYY"
                                                placeholder="Select date"
                                                style={{ width: '100%' }}
                                                showToday={false}
                                                showTime={false}
                                                open={false}
                                                />
                                            </Form.Item> */}

                        {/* as per bhaskar  request 09/09/2024 */}
                        <Form.Item
                          name="date_of_birth"
                          label="DOB"
                        // rules={[
                        //     {
                        //     required: true,
                        //     message: "DOB is Required",
                        //     },
                        // ]}
                        >
                          <DateInput
                            value={dob}
                            onChange={handleDateChange}
                            isError={isDOBValidationError}
                          />
                          <span style={{ color: "#ff4d4f" }}>
                            {dOBValidationErrorMsg}
                          </span>
                        </Form.Item>

                        {/* <Row >
                                                   
                                                    <Col xs={24} sm={8}>
                                                        <Form.Item name="date_of_birth"
                                                            label="Date of Birth"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'DOB is required',
                                                                },
                                                            ]}>
                                                            <Input placeholder="" />
                                                            <span style={{
                                                                fontSize:'11px',
                                                                color:'#8e8e8e',
                                                                
                                                            }}>Day</span>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={8}>
                                                        <Form.Item name="date_of_birth"
                                                            label=" "
                                                            rules={[
                                                                {
                                                                    required: false,
                                                                    message: 'DOB is required',
                                                                },
                                                            ]}
                                                            
                                                            >
                                                            <Input placeholder=""  />
                                                            <span style={{
                                                                fontSize:'11px',
                                                                color:'#8e8e8e',
                                                                
                                                            }}>Month</span>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={8}>
                                                        <Form.Item name="date_of_birth"
                                                            label="&nbsp;"
                                                            rules={[
                                                                {
                                                                    required: false,
                                                                    message: 'DOB is required',
                                                                },
                                                            ]}>
                                                            <Input placeholder="" />
                                                            <span style={{
                                                                fontSize:'11px',
                                                                color:'#8e8e8e',

                                                            }}>Year</span>
                                                        </Form.Item>
                                                    </Col>
                                                </Row> */}
                      </Col>

                      <Col xs={24} sm={12}>
                        <Form.Item name="gender" label="Gender">
                          <Radio.Group
                            onChange={onGenderChange}
                            optionType="button"
                            buttonStyle="solid"
                          >
                            <Radio.Button value="M">Male</Radio.Button>
                            <Radio.Button value="F">Female</Radio.Button>
                            <Radio.Button value="O">Other</Radio.Button>
                          </Radio.Group>
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12}>
                        <Form.Item
                          name="member_fname"
                          label="First Name"
                          rules={[
                            {
                              required: true,
                              message: "First name is required",
                            },
                          ]}
                        >
                          <Input
                            placeholder=""
                            onChange={(e) => {
                              form.setFieldsValue({
                                member_fname: e.target.value.toUpperCase(),
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12}>
                        <Form.Item name="member_lname" label="Last Name">
                          <Input
                            placeholder=""
                            onChange={(e) => {
                              form.setFieldsValue({
                                member_lname: e.target.value.toUpperCase(),
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12}>
                        <Form.Item
                          name="primary_mobile"
                          label="Primary Mobile"
                          rules={[
                            {
                              required: true,
                              message: "Primary mobile is required",
                            },
                          ]}
                        >
                          <Input
                            placeholder=""
                            addonBefore="+91"
                            onChange={(e) => {
                              handleMobileNumberInput(e, "primary_mobile");
                            }}
                            maxLength={10}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12}>
                        <Form.Item name="whatsapp_no" label="Whatsapp No">
                          <Input
                            placeholder=""
                            addonBefore="+91"
                            onChange={(e) => {
                              handleMobileNumberInput(e, "whatsapp_no");
                            }}
                            maxLength={10}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12}>
                        <Form.Item
                          name="primary_email"
                          label="Primary Email"
                          rules={[
                            { type: "email", message: "Invalid email format" },
                          ]}
                        >
                          <Input
                            placeholder=""
                            onChange={(e) => {
                              form.setFieldsValue({
                                primary_email:
                                  e.target.value.toLocaleLowerCase(),
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} xl={12}>
                        <Form.Item name="gstin_no" label="GSTIN">
                          <Input
                            placeholder=""
                            maxLength={15}
                            onChange={(e) => {
                              form.setFieldsValue({
                                gstin_no: e.target.value.toUpperCase(),
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={24} xl={8}>
                    <Form.Item name="file" label="Profile Pic">
                      <CustomFileUploadProfile
                        inputFileRef={inputFileRef}
                        file={file}
                        handleFileChange={handleFileChange}
                        onBtnClick={onBtnClick}
                        removePhoto={removePhoto}
                        profilePic={editMemberProfilePic}
                        laravelImagePath={laravelImagePath}
                      />
                    </Form.Item>
                    <Form.Item name="is_file_change" hidden={true}>
                      <Input type="text" />
                    </Form.Item>
                    <Form.Item name="is_file_deleted" hidden={true}>
                      <Input type="text" />
                    </Form.Item>
                  </Col>

                  {/* <Col className="gutter-row" xs={24} xl={8}>
                                        <Form.Item name="date_of_join" label="Date of joining">
                                            <DatePicker
                                                format="YYYY-MM-DD"
                                                onChange={onChange}
                                                style={{ width: "100%" }}
                                            />
                                        </Form.Item>
                                    </Col> */}

                  {/* <Col xs={24} xl={8}>
                                        <Form.Item name="billing_name" label="Billing Name">
                                            <Input placeholder="" />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} xl={8}>
                                        <Form.Item name="gstin_no" label="GSTIN" >
                                            <Input placeholder="" maxLength={15} />
                                        </Form.Item>
                                    </Col> */}
                </Row>
              </Panel>

              <Panel
                header="Address Info"
                key="2"
                style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }}
              >
                <Row gutter={20}>
                  <Col xs={24} xl={18}>
                    <Row gutter={20}>
                      <Col xs={24} xl={12}>
                        <Form.Item name="address_one" label="Address Line 1">
                          <TextArea
                            rows={2}
                            placeholder=""
                            onChange={(e) => {
                              form.setFieldsValue({
                                address_one: e.target.value.toUpperCase(),
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} xl={12}>
                        <Form.Item name="address_two" label="Address Line 2">
                          <TextArea
                            rows={2}
                            placeholder=""
                            onChange={(e) => {
                              form.setFieldsValue({
                                address_two: e.target.value.toUpperCase(),
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {/* <Row justify="end">
                                    <Col>
                                        <Form.Item>
                                            <Button htmlType="submit" shape="round"> Next <RightOutlined /></Button>
                                        </Form.Item>
                                    </Col>
                                </Row> */}
              </Panel>

              <Panel
                header="Guardian Info"
                key="3"
                style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }}
              >
                <Row gutter={20}>
                  <Col xs={24} xl={24}>
                    <Row gutter={20}>
                      <Col xs={24} xl={6}>
                        <Form.Item name="father_name" label="Father's Name">
                          <Input
                            placeholder=""
                            onChange={(e) => {
                              form.setFieldsValue({
                                father_name: e.target.value.toUpperCase(),
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} xl={6}>
                        <Form.Item
                          name="father_mobile"
                          label="Father's Mobile No"
                        >
                          <Input
                            placeholder=""
                            onChange={(e) => {
                              handleMobileNumberInput(e, "father_mobile");
                            }}
                            maxLength={10}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} xl={6}>
                        <Form.Item
                          name="father_occupation_id"
                          label="Father's Occupation"
                        >
                          <Select
                            className="text-left"
                            showSearch
                            placeholder="Search to Select"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              // option.children.includes(input)
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            filterSort={(optionA, optionB) =>
                              optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                            }
                            allowClear={true}
                          >
                            {/* <Option value="">Select</Option> */}
                            {occupationList.length > 0
                              ? occupationList.map((occupation_list) => (
                                <Option
                                  key={occupation_list.id}
                                  value={occupation_list.id}
                                >
                                  {occupation_list.occupation_name}
                                </Option>
                              ))
                              : ""}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={6}>
                        <Form.Item name="father_company" label="Father Company">
                          <Input
                            placeholder=""
                            onChange={(e) => {
                              form.setFieldsValue({
                                father_company: e.target.value.toUpperCase(),
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <Row gutter={20}>
                  <Col xs={24} xl={24}>
                    <Row gutter={20}>
                      <Col xs={24} xl={6}>
                        <Form.Item name="monther_name" label="Mother's Name">
                          <Input
                            placeholder=""
                            onChange={(e) => {
                              form.setFieldsValue({
                                monther_name: e.target.value.toUpperCase(),
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} xl={6}>
                        <Form.Item
                          name="mother_mobile"
                          label="Mother's Mobile No"
                        >
                          <Input
                            placeholder=""
                            onChange={(e) => {
                              handleMobileNumberInput(e, "mother_mobile");
                            }}
                            maxLength={10}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={6}>
                        <Form.Item
                          name="mother_occupation_id"
                          label="Mother's Occupation"
                        >
                          <Select
                            className="text-left"
                            showSearch
                            placeholder="Search to Select"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              // option.children.includes(input)
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            filterSort={(optionA, optionB) =>
                              optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                            }
                            allowClear={true}
                          >
                            {/* <Option value="">Select</Option> */}
                            {occupationList.length > 0
                              ? occupationList.map((occupation_list) => (
                                <Option
                                  key={occupation_list.id}
                                  value={occupation_list.id}
                                >
                                  {occupation_list.occupation_name}
                                </Option>
                              ))
                              : ""}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={6}>
                        <Form.Item name="mother_company" label="Mother Company">
                          <Input
                            placeholder=""
                            onChange={(e) => {
                              form.setFieldsValue({
                                mother_company: e.target.value.toUpperCase(),
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Panel>

              <Panel
                header="Schooling Info"
                key="4"
                style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }}
              >
                <Row gutter={20}>
                  <Col xs={24} xl={18}>
                    <Row gutter={20}>
                      <Col xs={24} xl={8}>
                        <Form.Item name="school" label="School">
                          <Input
                            placeholder=""
                            onChange={(e) => {
                              form.setFieldsValue({
                                school: e.target.value.toUpperCase(),
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} xl={8}>
                        <Form.Item name="mem_class" label="Class">
                          <Input
                            placeholder=""
                            onChange={(e) => {
                              form.setFieldsValue({
                                mem_class: e.target.value.toUpperCase(),
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} xl={8}>
                        <Form.Item name="weekly_holiday" label="Weekly Holiday">
                          <Input
                            placeholder=""
                            onChange={(e) => {
                              form.setFieldsValue({
                                weekly_holiday: e.target.value.toUpperCase(),
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} xl={8}>
                        <Form.Item name="school_timing" label="School Timing">
                          <Input
                            placeholder=""
                            onChange={(e) => {
                              form.setFieldsValue({
                                school_timing: e.target.value.toUpperCase(),
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {/* <Row justify="end">
                                    <Col>
                                        <Form.Item>
                                            <Button htmlType="submit" shape="round"> Next <RightOutlined /></Button>
                                        </Form.Item>
                                    </Col>
                                </Row> */}
              </Panel>

              <Panel
                header="Other Info"
                key="5"
                style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }}
              >
                <Row gutter={20}>
                  <Col xs={24} xl={6}>
                    <Form.Item name="is_beginner" label="Is Beginner">
                      <Radio.Group
                        onChange={onGenderChange}
                        defaultValue="Y"
                        optionType="button"
                        buttonStyle="solid"
                      >
                        <Radio.Button value="Y">Yes</Radio.Button>
                        <Radio.Button value="N">No</Radio.Button>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  {/* <Col xs={24} xl={8}>
                                        <Form.Item name="playing_for" label="Playing For">
                                            <Input placeholder="" />
                                        </Form.Item>
                                    </Col> */}

                  <Col xs={24} xl={6}>
                    <Form.Item name="earlier_playing" label="Earlier Playing">
                      <Input
                        placeholder=""
                        onChange={(e) => {
                          form.setFieldsValue({
                            earlier_playing: e.target.value.toUpperCase(),
                          });
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                {/* <Row justify="end">
                                    <Col>
                                        <Form.Item>
                                            <Button htmlType="submit" shape="round"> Next <RightOutlined /></Button>
                                        </Form.Item>
                                    </Col>
                                </Row> */}
              </Panel>
            </Collapse>

            <Row justify="end" style={{ backgroundColor: "#fafafa" }}>
              <Col>
                <Form.Item>
                  {isSaveLoaderEnable ? (
                    <>
                      {" "}
                      <Spin indicator={commonUtility.antIcon} />
                    </>
                  ) : (
                    <>
                      <Button
                        htmlType="submit"
                        className="custom-button-green"
                        shape="round"
                        style={{ margin: 8, border: 0 }}
                      >
                        {" "}
                        Save <RightOutlined />
                      </Button>
                    </>
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>

        {/* <Col className="login-first-step-block-1" xs={24} xl={8}>
                    <Row gutter={20} justify="center">
                        <Col>



                            <Card bordered={false}
                                style={{

                                    margin: '1rem auto',
                                    boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px'
                                }}
                            >



                            </Card>



                        </Col>
                    </Row>


                    <Row >
                        <Col xs={24} xl={12}>
                            <Card>
                                <h3>{totalRegistration}</h3>
                                <p>Total Registered</p>
                            </Card>


                        </Col>

                        <Col xs={24} xl={12}>

                            <Card>
                                <h3>{totalMemberRegistered}</h3>
                                <p>Member</p>
                            </Card>


                        </Col>

                        <Col xs={24} xl={12}>

                            <Card>
                                <h3>{totalStudentRegistered}</h3>
                                <p>Student</p>
                            </Card>

                        </Col>

                        <Col xs={24} xl={12}>

                            <Card>
                                <h3>{totalMalecount}</h3>
                                <p>Male</p>
                            </Card>

                        </Col>

                        <Col xs={24} xl={12}>

                            <Card>
                                <h3>{totalFemalecount}</h3>
                                <p>Female</p>
                            </Card>

                        </Col>

                        <Col xs={24} xl={12}>

                            <Card>
                                <h3>{totalTransgenderecount}</h3>
                                <p>Transgender</p>
                            </Card>

                        </Col>
                    </Row>




                </Col> */}
      </Row>

      {responseModal.isOpenModal ? (
        <>
          <ModalWithMessageAndActionReg responseModal={responseModal} />
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default BasicregWithCollapse;
